import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue } from 'apps/promo/actions/formAction';
import { getField } from 'apps/promo/components/form-multi/utils';
import { PARTNER_CODE } from 'apps/promo/constants/fieldsName';
import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'apps/promo/constants/formName';

import PromoInputTextPlain from './PromoInputTextPlain/PromoInputTextPlain';

const PromoInputPartnerCode = (props) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        const fields = {};
        fields[PARTNER_CODE] = getField(PARTNER_CODE, '', undefined, true, false, undefined, 'text');
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, '', PARTNER_CODE);
    }, []);

    const handlerChange = (e) => {
        setValue(e.target.value);
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, e.target.value, PARTNER_CODE);
    };

    return (
        <>
            <PromoInputTextPlain
                labelText={props.labelText}
                onChange={handlerChange}
                maxLength={10}
                type={'text'}
                name={props.name}
                formName={NO_AUTH_LOGIN_REGISTRATION_FORM_NAME}
                value={value}
                hasWhiteBg
                comment={props.hintText}
                commentWhite={props.commentWhite}
                commentCenter={props.commentCenter}
            />
        </>
    );
};

export default connect(null, { changeFormFieldValue })(PromoInputPartnerCode);
